import * as React from 'react';
import { SVGProps } from 'react';

const SvgQuestionMarkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.991 20.742c4.984 0 9.097-4.113 9.097-9.088 0-4.974-4.122-9.088-9.106-9.088-4.974 0-9.079 4.114-9.079 9.088 0 4.975 4.114 9.088 9.088 9.088Zm-.21-7.277c-.572 0-.888-.264-.888-.791v-.097c0-.826.474-1.292 1.125-1.749.773-.536 1.15-.826 1.15-1.389 0-.606-.465-1.01-1.186-1.01-.527 0-.914.263-1.204.712-.28.316-.413.588-.94.588-.43 0-.782-.28-.782-.72 0-.176.035-.334.096-.492.29-.862 1.345-1.565 2.918-1.565 1.635 0 3.015.87 3.015 2.4 0 1.054-.58 1.582-1.494 2.17-.58.378-.914.695-.94 1.17 0 .026-.01.07-.01.105-.026.378-.351.668-.86.668Zm-.01 2.812c-.597 0-1.09-.43-1.09-1.01 0-.58.484-1.011 1.09-1.011.598 0 1.081.43 1.081 1.01 0 .59-.492 1.011-1.08 1.011Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgQuestionMarkIcon;
